export default __webpack_public_path__ + "static/media/bamf.7816d053.jpg";